import React from 'react';

export function useCookiesAllowVideo(cookie) {
  if (cookie !== null && cookie !== '') {
    const checkConsent = () => {
      let groupsConsent = cookie.split('&').find((item) => item.includes('groups='))?.replace('groups=', '')
      let allConsent = true
      groupsConsent?.split('%2')?.map((item) => {
        let consent = item.split('%3A').find((value) => value === '1' || value === '0')
        if (consent === '0') {
          allConsent = false
        }
      })
      return allConsent;
    }
    return checkConsent()
  }
  return false
}
